import type { ReactNode } from 'react'
import { cx } from '../cx'
import type { Gap } from './Stack'
import s from './Grid.module.css'

/**
 * Columns that fold by the room they have, not by the device: a three-column grid inside a narrow card or on a phone
 * becomes one column on its own. This is where phone, tablet and desktop layouts come from; screens never set them.
 *
 * `cols.wide` is the most columns; `cols.narrow` the fewest (1 by default, 2 keeps pairs side by side on a phone).
 */
export function Grid(props: { children: ReactNode; cols: { narrow?: 1 | 2; wide: 1 | 2 | 3 | 4 }; gap?: Gap }) {
  const narrow = props.cols.narrow ?? 1
  return (
    <div className={s.room}>
      <div className={cx(s.grid, s[`gap-${props.gap ?? 'md'}`], s[`n${narrow}`], s[`w${props.cols.wide}`])}>
        {props.children}
      </div>
    </div>
  )
}
